import styled from "styled-components";
import img from "../../assets/image/imgMap";

/* CONTENEDOR PRINCIPAL */
export const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
`;

/* IMAGEN IZQUIERDA */
export const LeftImage = styled.div`
  flex: 1.3;
  background-color: #1a365d;
  background-image: url(${img.login});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  
  @media (max-width: 800px) {
    display: none;
  }
`;

/* PANEL DERECHO */
export const RightPanel = styled.div`
  flex: 0.7;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.background};
`;

/* TARJETA LOGIN */
export const Card = styled.div`
  background: var(--color-surface-base);
  padding: 3rem 2.5rem;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  border: var(--border-subtle);
  width: 380px;
  text-align: center;
`;

/* TÍTULO */
export const Title = styled.h2`
  margin-bottom: 2rem;
  color: var(--color-text-title);
  font-family: var(--font-display);
  font-weight: 600;
  letter-spacing: -0.02em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

/* INPUTS */
export const Input = styled.input`
  width: 100%;
  padding: 14px 16px;
  margin: 8px 0 16px 0;
  border: var(--border-medium);
  border-radius: var(--radius-sm);
  font-size: 1rem;
  font-family: var(--font-body);
  background-color: var(--color-surface-muted);
  color: var(--color-text-title);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: var(--color-accent);
    background-color: var(--color-surface-base);
    box-shadow: 0 0 0 4px rgba(3, 105, 161, 0.15);
  }

  &::placeholder {
    color: var(--color-text-muted);
  }
`;

/* BOTÓN */
export const Button = styled.button`
  width: 100%;
  padding: 14px;
  margin-top: 1rem;
  background: var(--color-accent);
  color: white;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 1.05rem;
  font-weight: 600;
  font-family: var(--font-body);
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(3, 105, 161, 0.2);

  &:hover {
    background: #025585; /* Un tono más oscuro que --color-accent */
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(3, 105, 161, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

/* ERROR */
export const ErrorMsg = styled.p`
  margin-top: 1rem;
  color: ${(props) => props.theme.TextAlert};
  font-size: 0.9rem;
`;
